import { RootState } from '../root.reducers';
import {
  AlarmNotificationProfile,
  InterceptAlarm,
  AlarmsInst,
  AlarmsDef,
  AdaptedAlarmNotificationProfile,
} from './alarmNotificationProfile.types';

export const getAlarmNotificationProfileList = (state: RootState): AlarmNotificationProfile[] =>
  state.alarmNotificationProfile.entities;

export const getAlarmNotificationProfile = (state: RootState): AlarmNotificationProfile | null =>
  state.alarmNotificationProfile.single;

export const getSelectedAlarmNotificationProfile = (state: RootState): AdaptedAlarmNotificationProfile[] =>
  state.alarmNotificationProfile.selected;

export const getAlarmNotificationProfileCreatedId = (state: RootState): string | null =>
  state.alarmNotificationProfile.createdId;

export const isAlarmNotificationProfileCreatePopupOpen = (state: RootState): boolean =>
  state.alarmNotificationProfile.ui.isCreatePopupOpen;

export const isAlarmNotificationProfileLoading = (state: RootState): boolean =>
  state.alarmNotificationProfile.ui.isLoading;

export const getInterceptAlarmList = (state: RootState): InterceptAlarm[] =>
  state.alarmNotificationProfile.interceptAlarmList;

export const getAlarmsInstList = (state: RootState): AlarmsInst[] =>
  state.alarmNotificationProfile.alarmsInstList;

export const getAlarmsDefList = (state: RootState): AlarmsDef[] =>
  state.alarmNotificationProfile.alarmsDefList;
